import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import {
  InspectorConsoleLine,
  InspectorConsoleSource,
} from 'ev-common/Inspector/InspectorTypes';

type InspectorData = {
  consoleLines: InspectorConsoleLine[];
  consoleHeight: number;
  consoleLogErrors: boolean;
  attachConsoleLog: boolean;
  lastSearch: string;
  groupFeaturesSettings: boolean;
};
const globalErrorInitialState: InspectorData = {
  consoleLines: [],
  consoleHeight: 80,
  consoleLogErrors: false,
  attachConsoleLog: false,
  groupFeaturesSettings: true,
  lastSearch: '',
};

export const inspectorSlice = createSlice({
  name: 'inspectorData',
  initialState: globalErrorInitialState,
  reducers: {
    toggleAttachConsoleLog(state) {
      state.attachConsoleLog = !state.attachConsoleLog;
    },
    toggleConsoleHeight(state) {
      state.consoleHeight = state.consoleHeight === 80 ? 180 : 80;
    },
    toggleConsoleLogErrors(state) {
      state.consoleLogErrors = !state.consoleLogErrors;
    },
    toggleGroupFeaturesSettings(state) {
      state.groupFeaturesSettings = !state.groupFeaturesSettings;
    },
    setLastSearch(state, { payload: search }: PayloadAction<string>) {
      state.lastSearch = search;
    },
    appendConsoleLine(
      state,
      { payload: consoleLine }: PayloadAction<InspectorConsoleLine>,
    ) {
      if (
        consoleLine.source === InspectorConsoleSource.Inspector ||
        state.consoleLogErrors
      ) {
        state.consoleLines.splice(0, 0, {
          ...consoleLine,
          timestampISO:
            consoleLine.timestampISO ?? DateTime.local().toFormat('HH:mm:ss'),
        });
      }
    },
  },
});
